export default __webpack_public_path__ + "static/media/working-forms-3x.1cce9fce.png";